import React, { useEffect } from 'react'
import { Link } from "react-router-dom";
import UpcommingAssessment from "./components/UpcomingAssessment";
import MockAssessment from './components/MockAssessment';
import { useTranslation } from 'react-i18next';

const ViewAssessement = () => {      

  const {t} = useTranslation()
  
  useEffect(() => {
      /*window.onbeforeunload = function(event) {
            event.preventDefault();
            event.returnValue = '';
          }*/
      sessionStorage.setItem('active-page-view', 'normal-exam')
    }, []);

  return (
    <div className='bg-whit'>       
        <section className='jumbotron bg-white p-4'>
            <Link to={'/candidate/assessments/view-assessments'} className='text-lg'>
              {t('exam')}
            </Link>
            <span className='mx-2'>/</span>
            <Link to={'/candidate/assessments/view-assessments'} className='text-lg text-customGreen'>
              {t('view-exams')}
            </Link>        
        </section>                    
          <div className='pb-3'>
             <UpcommingAssessment  />
          </div>               
    </div>
  )
}

export default ViewAssessement
